import { Fragment, PropsWithChildren, ReactElement, useEffect } from 'react';

import { AppLoader } from '@changegps/horizon-component-library';

import { useUserQuery } from '@/features/users';

const AuthProvider = (props: PropsWithChildren): ReactElement => {
  const userQuery = useUserQuery();
  const currentPath = window.location.pathname;
  const accessToken = localStorage.getItem('access_token');

  const publicPaths = ['/', '/login'];

  // Redirect authenticated users from public paths
  useEffect(() => {
    if (accessToken && publicPaths.includes(currentPath)) {
      window.location.href = '/home';
    }
  }, [accessToken, currentPath]);

  // Show loader while checking auth status or during redirect
  if (
    userQuery.isLoading ||
    (accessToken && publicPaths.includes(currentPath))
  ) {
    return <AppLoader />;
  }

  return <Fragment>{props.children}</Fragment>;
};

export default AuthProvider;
